import { StatusPill, type JudgementTone } from '@/design-system';

export interface JudgementPillProps {
    /** "Matig" - het woord, nooit het getal. */
    label: string;
    /** De kleur die de API bij het oordeel gaf; zonder kleur een neutraal label. */
    tone: JudgementTone | null;
    id?: string;
    className?: string;
}

/**
 * Een oordeel zoals het rapport het overal toont: het woord in zijn eigen kleur
 * - Goed groen, Voldoende geel, Matig oranje, Onvoldoende rood, Niet
 * waarneembaar blauw. Dezelfde kleuren als in de PDF (`--judgement-*`), en nooit
 * de huisstijl van het bedrijf: de koper leert de kleur in "Zo leest u dit
 * rapport" en herkent hem daarna bij elke kop.
 *
 * Klein en rustig, op een telefoon net zo groot als op een groot scherm (20 px
 * hoog): een lichte tint, het woord in een gedempte donkere tint van dezelfde
 * kleur, en een rand die er nauwelijks is. Lucas zag in de volle kleuren een
 * kermis; een lijst onderdelen moet als een lijst lezen.
 */
export function JudgementPill({ label, tone, id, className }: JudgementPillProps) {
    return tone ? (
        <StatusPill
            judgement={tone}
            size="xs"
            bordered
            weight="medium"
            {...(id ? { id } : {})}
            {...(className ? { className } : {})}
        >
            {label}
        </StatusPill>
    ) : (
        <StatusPill
            tone="neutral"
            size="xs"
            weight="medium"
            {...(id ? { id } : {})}
            {...(className ? { className } : {})}
        >
            {label}
        </StatusPill>
    );
}
